module.exports = __webpack_public_path__ + "img/fps.0f7a18c.svg";